import { Link } from 'react-router-dom';
import Logo from '@app/assets/vertical-logo.svg?react';
import GradientHeader from '@app/assets/images/gradient-header.png';
import { useEffect } from 'react';

export const FreeSignUpConfirmation = () => {
  // Get user data from localStorage
  const signupFormData = localStorage.getItem('signupFormData');
  const userData = signupFormData ? JSON.parse(signupFormData) : {};
  
  // Clean up localStorage after component mounts
  useEffect(() => {
    localStorage.removeItem('signupFormData');
    localStorage.removeItem('selectedPlan');
  }, []);
  
  // Get first name from full name
  const firstName = userData.fullName ? userData.fullName.split(' ')[0] : 'User';

  return (
    <div className="flex items-center justify-center flex-col min-h-screen py-6 bg-gray-50">
      <Logo width={139} height={110} className="mb-8" />

      <div className="bg-white text-left space-y-6 rounded-lg max-w-[600px] w-full shadow-sm overflow-hidden">
        <div className="w-full h-12 rounded-t-lg overflow-hidden">
          <img src={GradientHeader} alt="Header gradient" className="w-full h-full object-cover" />
        </div>
        <div className="px-10 pt-10 pb-8">
          <div className="text-center">
            {/*<h1 className="font-bold text-2xl mb-2">Your 14-Day Free Trial Has Started 🎉</h1>*/}
            <h1 className="font-bold text-2xl mb-2">Your Free Plan Is Now Active 🎉</h1>
          </div>

          <div className="space-y-4">
            <p className="text-gray-800">Hi {firstName},</p>

            <p className="text-gray-800">Welcome aboard! Your registration was successful, and you're all set to start using Echo Ratings.</p>

            <p className="text-gray-800">Explore our free features, after which you can upgrade to the Premium Plan anytime via Settings.</p>
          </div>

          <div className="text-center pt-4">
            <Link to="/" className="inline-block w-full bg-brand-baseBlue text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200">
              Explore Echo Ratings
            </Link>
          </div>

          <div className="text-center pt-4">
            <p className="text-gray-600 text-sm">
              Have any questions? Our support team is here to help at{' '}
              <a href="mailto:support@echoratings.com" className="text-brand-baseBlue underline">
                contact@echoratings.com
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="mt-10 text-center text-gray-500 text-sm space-y-1">
        <p>Echo Ratings</p>
        <p>©{new Date().getFullYear()} Echo Ratings</p>
      </div>
    </div>
  );
};
